import React, { type ForwardedRef, forwardRef } from 'react';

import { InputText, type InputTextProps } from '@pkg/primitives';
import { useMediaQuery } from '@pkg/providers';

import { Typography } from '../../../../../DesignSystem';

import { ClearAction, ClearActionWrapper, SearchWrapper } from './styles';

export interface SearchProps {
    // TODO: Expose more of `InputTextProps`.
    value?: string;
    placeholder?: string;
    onClear: () => void;
    onChange: InputTextProps['onChange'];
}

function SearchComponent(
    { value = '', placeholder = 'Search…', onClear, onChange }: SearchProps,
    ref: ForwardedRef<HTMLInputElement>,
) {
    const { tablet } = useMediaQuery();

    // TODO: We should be able to get a `Clear` value from
    // the global "common" i18n file. We should migrate the
    // entry found in `yat_nft_manager_search_clear`.
    const clearActionMarkup = tablet ? (
        <ClearActionWrapper>
            <ClearAction disabled={!value} onClick={onClear}>
                <Typography size={18} type="paragraph">
                    Clear
                </Typography>
            </ClearAction>
        </ClearActionWrapper>
    ) : null;

    return (
        <SearchWrapper>
            <InputText ref={ref} value={value} placeholder={placeholder} onChange={onChange} />
            {clearActionMarkup}
        </SearchWrapper>
    );
}

export const Search = forwardRef(SearchComponent);
